import React, { Fragment } from 'react';
import ReactTooltip from 'react-tooltip';
import { renderToStaticMarkup } from 'react-dom/server';
import { BRIDGE_SERVICE_NAMES, EMPTY_STRING } from '../../../constants/constants';

export function InsuranceEligibility(props) {
  const {
    services = [],
    modalFormat = false
  } = props;

  const getServiceName = (type) => {
    switch(type) {
      case BRIDGE_SERVICE_NAMES.CCM.id:
        return BRIDGE_SERVICE_NAMES.CCM.display;
      case BRIDGE_SERVICE_NAMES.FOLLOW_UP.id:
        return BRIDGE_SERVICE_NAMES.FOLLOW_UP.display;
      default:
        return EMPTY_STRING;
    }
  };

  const getEligibilityStatus = (service) => {
    const status = service?.status;
    let statusTextClass = '';
    let statusText = EMPTY_STRING;
    let statusInfo = '';

    if (status) {
      switch (status.toLowerCase()) {
        case "eligible":
          statusTextClass = 'text-ccm-green';
          break;
        case "ineligible":
        case "uninsured":
        case "ineffective":
          statusTextClass = 'text-ccm-red';
          if (!modalFormat && service?.messages) {
            statusInfo = (
              <div
                data-tip={renderToStaticMarkup(getEligibilityMessages(service))}
                data-for="tooltip-eligiblity-messages"
                data-html={true}
                className="bi bi-info-circle-fill ml-2 font-weight-normal"
              >
                <ReactTooltip id="tooltip-eligiblity-messages" type="info" place="bottom" effect="float" />
              </div>
            );
          }
          break;
        default:
          statusTextClass = '';
          break;
      }
      statusText = status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    }

    return (<div className={statusTextClass}>{statusText}{statusInfo}</div>);
  };

  const getEligibilityMessages = (service) => {
    return (<ul style={{
      textAlign: 'left',
      listStyleType: 'disc'
    }}>
      {service?.messages && Object.values(service?.messages).map((message, index) => (
        <li key={`${service.serviceType}_${index}`}>{message}</li>
      ))}
    </ul>);
  };

  const convertToDollars = (amount) => {
    if (amount === null || isNaN(amount)) {
      return EMPTY_STRING;
    }

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
    }).format(amount / 100);
  };

  const servicesArray = Object.values(services);

  return (
    <Fragment>
      { modalFormat ? (
        servicesArray.map((service, index) => (
        <div key={service?.serviceType}>
          <div className="pt-2 pb-2 ccm-table-container patient-eligibility-table">
            <table className="w-25">
              <thead>
                <tr>
                  <th>Service</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody data-test="modal_patientEligibilityGeneral">
                <tr>
                  <td data-test="modal_patientEligibilityService">{getServiceName(service?.serviceType)}</td>
                  <td data-test="modal_patientEligibilityStatus">{getEligibilityStatus(service)}</td>
                </tr>
              </tbody>
            </table>
          </div>
          { service?.status?.toLowerCase() !== 'eligible' && service?.messages && service?.messages.length > 0 && (
            <div className="pt-2 pb-2 ccm-table-container patient-eligibility-table">
              <table className="w-75">
                <thead>
                  <tr>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody data-test="modal_patientEligibilityMessages">
                  <tr>
                    <td data-test="modal_patientEligibilityMessage" className="text-ccm-red">
                      {getEligibilityMessages(service)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
          <div>Patient Estimated Responsibility</div>
          <div className="pb-2 ccm-table-container patient-eligibility-table">
            <table className="w-75">
              <thead>
                <tr>
                  <th className="font-weight-bold">Total</th>
                  <th>Deductible</th>
                  <th>Coinsurance</th>
                  <th>Copay</th>
                </tr>
              </thead>
              <tbody data-test="modal_patientEligibilityResponsibility">
                <tr key={service?.serviceType}>
                  <td data-test="modal_patientEligibilityTotal" className="font-weight-bold">{convertToDollars(service?.patientResponsibility?.total)}</td>
                  <td data-test="modal_patientEligibilityDeductible">{convertToDollars(service?.patientResponsibility?.deductible)}</td>
                  <td data-test="modal_patientEligibilityCoInsurance">{convertToDollars(service?.patientResponsibility?.coinsurance)}</td>
                  <td data-test="modal_patientEligibilityCoPay">{convertToDollars(service?.patientResponsibility?.copayment)}</td>
                </tr>
              </tbody>
            </table>
          </div>
          { index !== servicesArray.length - 1 && (<div className="border-bottom" />) }
        </div>
        ))
      ) : (
        <div className="ccm-table-container p-4 patient-eligibility-table">
          <table className="w-75">
            <thead>
              <tr>
                <th>Service</th>
                <th>Status</th>
                <th className="font-weight-bold">Total</th>
                <th>Deductible</th>
                <th>Coinsurance</th>
                <th>Copay</th>
              </tr>
            </thead>
            <tbody data-test="summary_patientEligibilityTableRows">
              {servicesArray.map((service) => (
              <tr key={service?.serviceType}>
                <td data-test="summary_patientEligibilityService">{getServiceName(service?.serviceType)}</td>
                <td data-test="summary_patientEligibilityStatus">{getEligibilityStatus(service)}</td>
                <td data-test="summary_patientEligibilityTotal" className="font-weight-bold">{convertToDollars(service?.patientResponsibility?.total)}</td>
                <td data-test="summary_patientEligibilityDeductible">{convertToDollars(service?.patientResponsibility?.deductible)}</td>
                <td data-test="summary_patientEligibilityCoInsurance">{convertToDollars(service?.patientResponsibility?.coinsurance)}</td>
                <td data-test="summary_patientEligibilityCoPay">{convertToDollars(service?.patientResponsibility?.copayment)}</td>
              </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Fragment>
  );
}

export default InsuranceEligibility;
